import React from 'react';

export interface IFullscreenContext {
  toggleFullscreen(element: HTMLElement): Promise<void>;
}

export const FullscreenContext = React.createContext<IFullscreenContext>({
  toggleFullscreen: null,
});

export const useFullscreen = () => React.useContext(FullscreenContext);
